import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {JobsComponent} from "./components/pages/jobs/jobs.component";
import {QuotesComponent} from "./components/pages/quotes/quotes.component";
import {AssetsComponent} from "./components/pages/assets/assets.component";
import {SignInComponent} from "./components/pages/sign-in/sign-in.component";
import {CanActivateGuard} from "./guards/can-activate.guard";
import {DashboardComponent} from "./components/pages/dashboard/dashboard.component";
import {RegisterComponent} from "./components/pages/register/register.component";
import {ForgotPasswordComponent} from "./components/pages/forgot-password/forgot-password.component";
import {EmailVerificationComponent} from "./components/pages/email-verification/email-verification.component";
import {ResetPasswordComponent} from "./components/pages/reset-password/reset-password.component";
import {PendingUsersComponent} from "./components/pages/pending-users/pending-users.component";
import {JobComponent} from "./components/pages/job/job.component";
import {QuoteComponent} from "./components/pages/quote/quote.component";
import {ServiceRequestComponent} from "./components/pages/service-request/service-request.component";
import {Permissions} from "./enums/permissions";
import {ServiceRequestsComponent} from "./components/pages/service-requests/service-requests.component";
import {InvitedUsersComponent} from "./components/pages/invited-users/invited-users.component";
import {
  JobAttachmentsDetailsComponent
} from "./components/pages/job-attachments-details/job-attachments-details.component";
import {
  QuoteAttachmentsDetailsComponent
} from "./components/pages/quote-attachments-details/quote-attachments-details.component";
import {CompleteRegistrationComponent} from "./components/pages/complete-registration/complete-registration.component";
import {UnsubscribeComponent} from "./components/pages/unsubscribe/unsubscribe.component";
import {UnsubscribeContactComponent} from "./components/pages/unsubscribe-contact/unsubscribe-contact.component";

const routes: Routes = [
  {
    path: 'unsubscribe',
    component: UnsubscribeComponent,
  },
  {
    path: 'unsubscribe-contact',
    component: UnsubscribeContactComponent,
  },
  {
    path: '',
    redirectTo: 'sign-in',
    pathMatch: 'full'
  },
  {
    path: 'sign-in',
    component: SignInComponent,
    pathMatch: 'full'
  },
  {
    path: 'register',
    component: RegisterComponent,
    pathMatch: 'full'
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    pathMatch: 'full'
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    pathMatch: 'full'
  },
  {
    path: 'verify-email',
    component: EmailVerificationComponent,
    pathMatch: 'full'
  },
  {
    path: 'complete-registration',
    component: CompleteRegistrationComponent,
    pathMatch: 'full',
  },
  {
    path: 'jobs',
    component: JobsComponent,
    canActivate: [CanActivateGuard],
    pathMatch: 'full',
    data: {
      requiredPermission: Permissions.ViewJobs,
      ownerOnly: false
    }
  },
  {
    path: 'job',
    component: JobComponent,
    canActivate: [CanActivateGuard],
    pathMatch: 'full',
    data: {
      requiredPermission: Permissions.ViewJobDetails,
      ownerOnly: false
    }
  },
  {
    path: 'job-attachments-details',
    component: JobAttachmentsDetailsComponent,
    canActivate: [CanActivateGuard],
    pathMatch: 'full',
    data: {
      requiredPermission: Permissions.ViewJobDetails,
      ownerOnly: false
    }
  },
  {
    path: 'quote-attachments-details',
    component: QuoteAttachmentsDetailsComponent,
    canActivate: [CanActivateGuard],
    pathMatch: 'full',
    data: {
      requiredPermission: Permissions.ViewQuoteDetails,
      ownerOnly: true
    }
  },
  {
    path: 'quote',
    component: QuoteComponent,
    canActivate: [CanActivateGuard],
    pathMatch: 'full',
    data: {
      requiredPermission: Permissions.ViewQuoteDetails,
      ownerOnly: true
    }
  },
  {
    path: 'quotes',
    component: QuotesComponent,
    canActivate: [CanActivateGuard],
    pathMatch: 'full',
    data: {
      requiredPermission: Permissions.ViewQuotes,
      ownerOnly: true
    }
  },
  {
    path: 'assets',
    component: AssetsComponent,
    canActivate: [CanActivateGuard],
    pathMatch: 'full',
    data: {
      requiredPermission: Permissions.ViewAssets,
      ownerOnly: false
    }
  },
  {
    path: 'pending-users',
    component: PendingUsersComponent,
    canActivate: [CanActivateGuard],
    pathMatch: 'full',
    data: {
      requiredPermission: Permissions.ViewPendingUsers,
      ownerOnly: false
    }
  },
  {
    path: 'invited-users',
    component: InvitedUsersComponent,
    canActivate: [CanActivateGuard],
    pathMatch: 'full',
    data: {
      requiredPermission: Permissions.ViewPendingUsers,
      ownerOnly: false
    }
  },
  {
    path: 'dashboard',
    canActivate: [CanActivateGuard],
    component: DashboardComponent,
    data: {
      requiredPermission: Permissions.ViewDashboards,
      ownerOnly: false
    },
    pathMatch: 'full',
  },
  {
    path: 'service-request',
    canActivate: [CanActivateGuard],
    component: ServiceRequestComponent,
    pathMatch: 'full',
    data: {
      requiredPermission: Permissions.CreateServiceRequest,
      ownerOnly: false,
      renteeRestricted: true
    }
  },
  {
    path: 'service-requests',
    component: ServiceRequestsComponent,
    canActivate: [CanActivateGuard],
    pathMatch: 'full',
    data: {
      requiredPermission: Permissions.ViewServiceRequests,
      ownerOnly: false,
      renteeRestricted: true
    }
  },
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule {

}
